import * as yup from "yup";

export const VALIDATION_SCHEMA = yup.object({
  name: yup.string().trim().required("Name is a required field."),
  db_name: yup.object().required("Please select a DB Name."),
  drafter: yup.object().required("Please select a Drafter."),
  approver: yup.object().required("Please select a Approver."),
});

export const INITIAL_VALUES = {
  name: "",
  db_name: "",
  drafter: "",
  approver: "",
  description: "",
};
